// Components==============
import { useEffect, useState } from 'react';
import { ProcesSteps } from 'typings';
import { getCorrectPhase } from 'utilities/getCorrectPhase';
import { useRedux } from './useRedux';
// =========================

export type EditableProcessEntity = ReturnType<typeof getEditableProcessEntity>;
export type ProcessGroups = ReturnType<typeof getProcessGroups>;

const getEditableProcessEntity = (process: ProcessProcessEntity) => ({
  description: process.description,
  order: parseInt(process.order),
  id: process.process_id,
  process_type: process.process_type,
  processId: process.id || undefined,
  finished: process.finished,
  users: process.users,
  date: process.date,
  date_type: process.date_type,
});

function getProcessGroups(
  processes: (ProcessProcessEntity | undefined)[] | undefined
) {
  const nestedProcesses: (EditableProcessEntity & {
    phase: ProcesSteps;
    activities: EditableProcessEntity[];
  })[] = [];

  processes
    ?.sort((a, b) => parseInt(a?.order || '0') - parseInt(b?.order || '0'))
    ?.forEach((process) => {
      if (process?.process_type === 'App\\Phase') {
        const editableProcessEntity = getEditableProcessEntity(process);

        nestedProcesses.push({
          ...editableProcessEntity,
          phase: getCorrectPhase(process.process_id - 1),
          activities: [getEditableProcessEntity(process)],
        });
      }

      if (
        process?.process_type === 'App\\Activity' ||
        process?.process_type === 'App\\Training'
      )
        nestedProcesses[nestedProcesses.length - 1].activities.push(
          getEditableProcessEntity(process)
        );
    });

  return nestedProcesses;
}

export function useProcessGroups(
  project?: ProjectProjectEntity,
  saveKey?: number
) {
  const process = useRedux((state) =>
    project?.process?.map((id) => state.process?.entities.byId[id])
  );

  const initialProcessGroups = () => getProcessGroups(process);

  const [processGroups, setProcessGroups] = useState(() =>
    initialProcessGroups()
  );
  const resetProcessGroups = () => setProcessGroups(initialProcessGroups());

  useEffect(() => {
    if (saveKey && saveKey > 0) setProcessGroups(initialProcessGroups());
  }, [saveKey]);

  const initializeProcessGroups = () => {
    const initialStart = {
      id: 6,
      order: -1,
      description: undefined,
      processId: undefined,
      process_type: 'App\\Phase' as ProcessType,
      finished: undefined,
      users: undefined,
      date: undefined,
      date_type: undefined,
    };

    const initialEnd = {
      id: 7,
      order: 999,
      description: undefined,
      processId: undefined,
      process_type: 'App\\Phase' as ProcessType,
      finished: undefined,
      users: undefined,
      date: undefined,
      date_type: undefined,
    };

    setProcessGroups([
      {
        ...initialStart,
        activities: [initialStart],
        phase: 'vertrekpunt',
      },
      {
        ...initialEnd,
        activities: [initialEnd],
        phase: 'eindpunt',
      },
    ]);
  };

  useEffect(() => {
    setProcessGroups(initialProcessGroups());
  }, [project?.author?.id]);

  return {
    processGroups,
    setProcessGroups,
    resetProcessGroups,
    initializeProcessGroups,
  };
}
